
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import PostLayout from "@src/layouts/PostLayout";
import InstaImage from "@src/components/InstaImage";
import ShopInfoBox from "@src/components/ShopInfoBox";
import LinkWithThumbnail from "@src/components/LinkWithThumbnail";
import { murakamiMasanori } from "@src/constants/authors";
import { harajukuBreadHarajukuLunchBreadImage } from "@src/constants/images";
import { meta as ryunokoPancakePageMeta } from "./ryunoko.mdx";
import { meta as kevelosPageMeta } from "./kevelos.mdx";
import { meta as theGreatBurgerPageMeta } from "./the_great_burger.mdx";
import { meta as minoringoPageMeta } from "./minoringo.mdx";
import { meta as yogoroPageMeta } from "./yogoro.mdx";
export const meta = {
  path: "/media/harajuku/bread",
  title: "【百名店限定！】原宿でパンのランチを食べたいならこの3つのお店！",
  description: "原宿でパンのランチが食べられるランチのお店をご紹介します。紹介するお店は、食べログの評価は全ての店舗が3.7を超え、百名店に選出の実績を残している名店揃い。その日の気分に合わせて、パンのランチを原宿で食べたい時にはぜひ活用ください！",
  topImg: harajukuBreadHarajukuLunchBreadImage,
  author: murakamiMasanori,
  tags: ["パン", "有名店", "おしゃれな内装", "あっさり", "人気店", "まとめ記事", "食べログ高評価", "行列情報", "メニュー詳細"]
};

const layoutProps = {
  meta
};
const MDXLayout = ({ children }) => (
  <PostLayout meta={meta}>{children}</PostLayout>
)
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`原宿でパンのランチが食べられるランチのお店をご紹介します。`}</p>
    <p>{`紹介するお店は、食べログの評価は全ての店舗が 3.7 を超え、百名店に選出の実績を残している名店揃い。`}</p>
    <p>{`お店の特徴や、ランチのメニューをご紹介。`}</p>
    <p>{`日によってランチ値段が変わることや行列の状況が変わることがあるので、パンのランチを原宿で食べたい時にはぜひ活用ください！`}</p>
    <h2>{`パンとエスプレッソと`}</h2>
    <InstaImage postId="By4KgQaF5G3" mdxType="InstaImage" />
    <p>{`4 年連続百名店に選ばれる原宿・表参道エリアでトップを走る人気のお店が「パンとエスプレッソと」。
食べログの評価は 3.8 を超えており、出来立てのパンを求めてランチだけでなく朝の時間帯にも行列ができています。`}</p>
    <h3>{`洗練されたデザインのお店`}</h3>
    <InstaImage postId="B8-ydEBFfjf" mdxType="InstaImage" />
    <p>{`原宿でランチをお店で食べる時もテイクアウトするときでも、写真にとりたくなるような洗練されたデザインが特徴。
木製の家具で統一されているお店は、原宿に佇むアパレルショップのような雰囲気で、テラス席も完備されています。`}</p>
    <h4>{`手提げ袋が可愛い`}</h4>
    <InstaImage postId="B87u1bcFxNi" mdxType="InstaImage" />
    <p>{`「パンとエスプレッソと」という大きなロゴが入った袋は、思わず写真がとりたくなりますよね。`}</p>
    <h3>{`行列情報`}</h3>
    <p>{`パン屋さんなので朝方に行列が並ぶことが多く、行列は特に朝の時間帯にできることが多いそうです。
ランチの時間帯は比較的空いているそうなので、ランチの場合は何時に行っても入れる可能性が高いです。`}</p>
    <h3>{`ランチメニュー`}</h3>
    <InstaImage postId="BpYW7diAv7R" mdxType="InstaImage" />
    <p>{`パンのランチは平日と週末で 2 つのセットがあります。平日のほうがお値段がお手頃でですが、行く日に合わせてパンのランチの値段をチェックしてお越しください！`}</p>
    <h4>{`ウィークデイランチセット`}</h4>
    <p>{`※平日 11:00 ～ 15:00`}</p>
    <p>{`A 　サラダランチセット（たっぷりサラダ・パン２種・ドリンク）　 1,000 円
B 　パニーニセット（お好みのパニーニ・サイドディッシュ・ドリンク）　 950 円`}</p>
    <h4>{`ウィークエンドランチセット`}</h4>
    <p>{`※週末 11:00 ～ 15:00`}</p>
    <p>{`A 　パニーニセット（お好みのパニーニ・サイドディッシュ・焼き菓子・ドリンク）　 1,100 円
B 　ウィークエンドブランチセット（ジュース・パンとキッシュの盛り合わせ・ハム盛り合わせ・サイドディッシュ・チーズ・バター・ハチミツ・コンフィチュール・ドリンク）　 1,600 円`}</p>
    <ShopInfoBox shopId="brisonq23akg00cd2nfg" mdxType="ShopInfoBox" />
    <hr></hr>
    <h2>{`レフェクトワール`}</h2>
    <InstaImage postId="By4opwZjxQ0" mdxType="InstaImage" />
    <p>{`原宿から駅徒歩 4 分の距離にあるタケオキクチビルに位置し、食べログの評価は 3.7 を超え、座グレートバーガー と同じく、3 年連続百名店にも選出されている有名なのお店です。`}</p>
    <h3>{`行列情報`}</h3>
    <p>{`レフェクトワールでは、ランチの時間帯はテイクアウトの方が多いのが特徴的で、イートインスペースは比較的空いていることが多いです。
ランチの時間帯でも並ばずに入れる食べログ 3.7 のお店は中々ないので隠れ家的なお店と言えるでしょう！`}</p>
    <h3>{`ランチセットがお得`}</h3>
    <InstaImage postId="vSaphbyzVh" mdxType="InstaImage" />
    <InstaImage postId="B7lMS6FAGZl" mdxType="InstaImage" />
    <p>{`サラダとドリンクのランチセットが 1,020 円とお得なお値段で食べられます！`}</p>
    <p>{`メインは、クロックムッシュやキッシュ、サラダ、スープの 4 種類から選ぶことができ、パンだけでなくマフィンも豊富に取り揃えられているので、その日の気分に合わせてランチをカスタマイズして食べてみるのがオススメです！`}</p>
    <ShopInfoBox shopId="brf4aea23akg00d4drsg" mdxType="ShopInfoBox" />
    <hr></hr>
    <h2>{`ジャンフランソワ Echika 表参道`}</h2>
    <InstaImage postId="B9MHNb_AgqB" mdxType="InstaImage" />
    <p>{`食べログの評価は 3.7 を超え、百名店に選出されているパンの人気店。
原宿からは少し遠く、表参道の「マルシェ・ドゥ・メトロ」の中に店舗があるため、天気が悪い雨の日でも気にせずに行くことができるのがポイント。
表参道からアクセスできる方は原宿ではなく表参道からのアクセスがおすすめです。`}</p>
    <h3>{`行列情報`}</h3>
    <p>{`いつも行列が並んでいるわけではないですが、土日には行列ができることが多いそうです。また行列の列がイートインスペース側にあるそうなので、座ってパンを食べる時も落ち着かない可能性があります。行列ができる時間帯を外して、朝早めの時間帯か、お昼過ぎの時間帯がパンを食べるおすすめの時間になっています。`}</p>
    <h3>{`ランチメニュー`}</h3>
    <InstaImage postId="B85OZIZg-UV" mdxType="InstaImage" />
    <p>{`決まったランチメニューはなく、お好きなパンとドリンクを選んでイートインスペースで食べるのが、ジャンフランソワ Echika 表参道のランチの食べ方です。そんなにお腹が空いていないけど、美味しいパン屋さんでサクッとお昼ごはんを済ませたい方には、ジャンフランソワ Echika 表参道はおすすめのお店になっています。`}</p>
    <ShopInfoBox shopId="brish8q23akg00cd2n60" mdxType="ShopInfoBox" />
    <hr></hr>
    <h3>{`おわりに　`}</h3>
    <p>{`原宿でパンのランチができるお店を紹介してきましたが、いかがでしたでしょうか。ガッツリランチを食べるほどではない時に、サクッと食べられるお店としてパン屋さんは相性が良いですよね！原宿でパン屋さんのランチを食べたい時には、名店３選をぜひご参考にしてください！`}</p>

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;